<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >{{ $t("Cookies.editData") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-card class="rounded-lg">
                <v-card-title primary-title class="pa-2 pl-4 black--text">
                  {{ $t("Cookies.text2") }}
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-5">
                  <v-layout row wrap justify-center align-center>
                    <v-flex xs11 lg5 md5 pa-2>
                      <b class="black--text">{{ $t("Cookies.text3") }}</b>
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="SystemName"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs11 lg5 md5 pa-2>
                      <b class="black--text">{{ $t("Cookies.text4") }}</b>
                      <v-text-field
                        outlined
                        dense
                        color="info"
                        v-model="Hostname"
                        :rules="HostRules"
                        :error-messages="ErrorMessageHost"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center mt-n8>
                    <v-flex xs11 lg10 pa-2>
                      <v-radio-group v-model="ConsentType" row disabled>
                        <v-radio
                          :label="$t('onechat.text6')"
                          color="#077893"
                          value="SentGeneral"
                        >
                        </v-radio>
                        <v-radio
                          :label="$t('onechat.text7')"
                          color="#077893"
                          value="SentGroup"
                        >
                        </v-radio>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap justify-center align-center mt-n4>
                    <v-flex xs12 lg5 pa-2 v-if="ConsentType === 'SentGeneral'">
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("onechat.text8") }} </b>
                      <v-select
                        disabled
                        dense
                        :items="ItemPolicy"
                        :label="$t('onechat.text8')"
                        item-text="Title"
                        v-model="SelectPolicy"
                        item-value="PolicyId"
                        outlined
                        :rules="[(v) => !!v]"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs11 lg5 pa-2 v-if="ConsentType === 'SentGeneral'">
                      <b class="red--text mr-1">*</b>
                      <b>{{ $t("onechat.text9") }} </b>
                      <v-select
                        disabled
                        v-if="ConsentType === 'SentGeneral'"
                        dense
                        :items="ItemConsentGeneral"
                        :label="$t('onechat.text9')"
                        item-text="HeaderConsent"
                        v-model="SelectConsentGeneral"
                        item-value="ConsentId"
                        outlined
                        :rules="[(v) => !!v]"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs11 lg5 pa-2 v-if="ConsentType === 'SentGroup'">
                      <b class="red--text mr-1">*</b>
                      <!-- <b>{{ $t("onechat.text9") }} </b> -->
                      <b>{{ $t("mcg.consent2") }} </b>
                      <!-- <v-select dense :items="ItemConsentGroup" :label="$t('onechat.text9')" :rules="[(v) => !!v]"
                          item-text="GroupName" v-model="SelectConsentGroup" item-value="GroupId" outlined>
                        </v-select> -->
                      <!-- :rules="[(v) => !!v]" -->
                      <v-select
                        disabled
                        dense
                        :items="ItemConsentGroup"
                        :label="$t('mcg.consent2')"
                        item-text="GroupName"
                        v-model="SelectConsentGroup"
                        item-value="GroupId"
                        outlined
                        :rules="[(v) => !!v]"
                      >
                      </v-select>
                    </v-flex>
                    <v-flex xs11 lg5></v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout row wrap justify-center align-center pb-5>
                    <!-- <v-flex xs2 lg2 mr-2>
                      <v-btn block dark outlined color="#077893" @click="Fn_CreatePolicy">บันทึกฉบับร่าง</v-btn>
                    </v-flex> -->
                    <v-flex xs10 md3 lg3>
                      <v-btn
                        block
                        dark
                        color="#077893"
                        :loading="LoadingUpdate"
                        @click="Fn_UpdateService"
                        >{{ $t("policy.text6") }}</v-btn
                      >
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: {},
  data: function () {
    return {
      valid: true,
      ItemPolicy: [],
      SystemName: "",
      Hostname: "",
      ErrorMessageHost: "",
      ConsentType: "",
      SelectConsentGeneral: "",
      SelectConsentGroup: " ",
      SelectPolicy: "",
      ItemConsentGeneral: [],
      ItemConsentGroup: [],
      LoadingUpdate: false,
      HostRules: [
        (v) => !!v || "กรุณากรอกชื่อโดเมน",
        (v) => /.+.+\..+/.test(v) || "รูปแบบของโดเมนไม่ถูกต้อง",
      ],
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    _BusinessName: {
      get() {
        return this.Business.BusinessNameTH || "-";
      },
    },
    Fn_CheckType() {
      if (this.ConsentType == "SentGeneral") {
        this.SelectConsentGroup = [];
      } else {
        this.SelectPolicy = [];
        this.SelectConsentGeneral = [];
      }
    },
  },
  mounted() {
    this.GetService();
    this.Fn_GetPolicy();
    this.Fn_GetConsentGeneral();
    this.Fn_GetConsentGroup();
  },
  methods: {
    Fn_SelectTypeDepartment() {
      if (this.TypeSent === "SentDepartment") {
        this.Fn_GetAllDepartment();
      } else if (this.TypeSent === "SentAll") {
        this.SelectDepartment = "";
        this.SelectRole = "";
        this.$refs.formConsent.resetValidation();
        this.Fn_GetAllEmployee();
      }
    },
    async Fn_GetPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetApiAllDetailPolicy",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGeneral() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetApiAllDetailConsent",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemConsentGeneral = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      // var Headers = {
      //
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetApiAllGroupConsent",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsentGroup = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_UpdateService() {
      if (this.$refs.form.validate()) {
        this.LoadingUpdate = true;
        var payload = {
          BusinessId: this.$cookies.get("BusinessId"),
          AccountId: this.$cookies.get("OneAccountId"),
          ServiceId: this.$cookies.get("ServiceId"),
          ServiceName: this.SystemName,
          Hostname: this.Hostname,
          PolicyId: this.SelectPolicy,
          ConsentId: this.SelectConsentGeneral,
          GroupId: this.SelectConsentGroup,
        };
        this.axios
          .post(
            process.env.VUE_APP_API_FACTORING_SERVICE +
              "webscript/UpdateService",
            payload
          )
          .then((response) => {
            this.LoadingUpdate = false;

            if (response.data.Status === "OK") {
              this.UpdateService = response.data.Message;

              Toast.fire({
                icon: "success",
                title: response.data.Message,
              });
              this.$router.push("/cookies-index");
            } else {
              Toast.fire({
                icon: "error",
                title: response.data.ErrorMessage,
              });
            }
          })
          .catch((error) => {
            this.LoadingUpdate = false;
            if (error.response) {
              Toast.fire({
                icon: "error",
                title: error.response.data.ErrorMessage,
              });
            } else if (error.request) {
              Toast.fire({
                icon: "error",
                title: error.request,
              });
            } else {
              Toast.fire({
                icon: "error",
                title: error.message || error,
              });
            }
          });
      }
    },
    GetService() {
      this.loadingDownloadData = true;
      var payload = {
        AccountId: this.$cookies.get("OneAccountId"),
        BusinessId: this.$cookies.get("BusinessId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
        ServiceId: this.$cookies.get("ServiceId"),
      };
      // var Headers = {
      //   AccountId: this.$cookies.get("OneAccountId"),
      // };
      // var dataEncode = await authorization.encodeDataNew(payload);
      // var auth = await authorization.encodeDataNew(Headers);
      // var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE + "webscript/GetService",
          // { Data: dataEncode },
          // { headers }
          payload
        )
        .then((response) => {
          this.loadingDownloadData = false;
          if (response.data.Status === "OK") {
            this.Service = response.data.Message;
            this.Hostname = response.data.Message[0].Hostname;
            this.SystemName = response.data.Message[0].ServiceName;
            this.SelectConsentGroup = response.data.Message[0].GroupId;
            this.SelectConsentGeneral = response.data.Message[0].ConsentId;
            this.SelectPolicy = response.data.Message[0].PolicyId;
            if (this.SelectConsentGroup == "") {
              this.ConsentType = "SentGeneral";
            } else {
              this.ConsentType = "SentGroup";
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.Message.Status,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/cookies-index");
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
